import { useSelector } from "react-redux"
import { useNavigate, useLocation } from "react-router-dom"
import { ROLES_MENU } from "@router/Routes"
import Nav from '@ui/layout/Nav'
import { useTranslation } from "react-i18next"
import Div from "@ui/layout/Div"

const AdminNavigation = () => {
  const { logguedUser, mission } = useSelector(state => state.main)
  const [t] = useTranslation('common')
  const navigate = useNavigate()
  const location = useLocation()
  const activeRole = mission.isAdminPanel ? 'ROLE_ADMIN_PANEL' : logguedUser.roles

  const goTo = target => navigate(target)

  const getChildrenStart = () => {
    const routes = ROLES_MENU[`${activeRole}_MENU`]
    return Object.keys(routes).map(route => {
      if ('object' !== typeof routes[route]) {
        return (
          <a
            className={`navbar-item ${location.pathname === routes[route] ? 'is-active' : ''}`}
            onClick={() => goTo(routes[route])}
            key={`admin-menu-${route.toLowerCase()}`}
          >
            {t(`labels.${route}`)}
          </a >
        )
      } else {
        return (
          <Div cssClass="navbar-item has-dropdown is-hoverable" key={`admin-menu-${route.toLowerCase()}`}>
            <a className={`navbar-link ${Object.values(routes[route]).indexOf(location.pathname) >= 0 ? 'is-active' : ''}`}>
              {t(`labels.${route}`)}
            </a>
            <Div cssClass="navbar-dropdown">
              {Object.keys(routes[route]).map(childRoute => {
                let target = routes[route][childRoute]
                return (
                  <a
                    className={`navbar-item ${location.pathname === target ? 'is-active' : ''}`}
                    onClick={() => goTo(target)}
                    key={`admin-menu-${childRoute.toLowerCase()}`}
                  >
                    {t(`labels.${childRoute}`)}
                  </a>
                )
              })}
            </Div>
          </Div>
        )
      }

    })
  }

  return (
    <Nav
      cssClass='user-menu container is-hidden-mobile'
      childrenStart={getChildrenStart()}
    />
  )
}

export default AdminNavigation